module.exports = __webpack_public_path__ + "static/media/teachers-03.c2e341bf.png";